interface FooterNavigationLinkProps {
  href: string;
  text: string;
}

interface Props {
  address?: string;
  className: string;
  copyright?: string;
  footerLinks?: FooterNavigationLinkProps[];
  socialLinks?: {
    facebook?: string;
    linkedIn?: string;
    twitter?: string;
    youtube?: string;
  };
}

const Footer = ({
  address,
  className,
  copyright,
  footerLinks,
  socialLinks,
}: Props) => {
  const FooterNavigationLink = ({ href, text }: FooterNavigationLinkProps) => (
    <raul-footer-navigation-link>
      <a href={href} rel="noreferrer" target="_blank">
        {text}
      </a>
    </raul-footer-navigation-link>
  );

  return (
    <div className={className}>
      <raul-footer>
        {address && (
          // @ts-expect-error: dangerouslySetInnerHTML "does not exist on type"
          <raul-footer-contact dangerouslySetInnerHTML={{ __html: address }} />
        )}
        {copyright && (
          <raul-footer-copyright
            // @ts-expect-error: dangerouslySetInnerHTML "does not exist on type"
            dangerouslySetInnerHTML={{ __html: copyright }}
          />
        )}
        {socialLinks && (
          <raul-footer-social-icons
            facebook-url={socialLinks.facebook}
            linkedin-url={socialLinks.linkedIn}
            twitter-url={socialLinks.twitter}
            youtube-url={socialLinks.youtube}
          />
        )}
        {footerLinks && (
          <raul-footer-navigation-links>
            {footerLinks.map((link) => (
              <FooterNavigationLink
                key={link.href}
                href={link.href}
                text={link.text}
              />
            ))}
          </raul-footer-navigation-links>
        )}
      </raul-footer>
    </div>
  );
};

export default Footer;
